<template>
  <page-layout title="Balises SPOT" :nav-items="navItems">
    <template v-slot:breadcrumb>
      <li><router-link :to="{ name: 'home' }">Dashboard</router-link></li>
      <li class="is-active"><a href="#">Balises SPOT</a></li>
    </template>
    <router-view />
  </page-layout>
</template>

<script>
import PageLayout from '@components/PageLayout.vue'

export default {
  name: 'SpotTrackersPage',

  components: {
    PageLayout,
  },

  metaInfo() {
    return {
      title: 'Balises SPOT',
    }
  },

  computed: {
    navItems() {
      return [
        {
          label: 'Général',
          active: this.$route.name === 'spotTracker.list',
          to: { name: 'spotTracker.list' },
        },
        {
          label: "Transfert d'abonnements",
          active: this.$route.name === 'spotTracker.subscription',
          to: { name: 'spotTracker.subscription' },
        },
      ]
    },
  },
}
</script>
